import { CthLogScreen } from '@/screens/completeTheHand/CthLogScreen'

export default function CthLogRoute() {
  return <CthLogScreen />
}
